import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const NumberBadge = styled.div`
    display: flex;
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 16777200px;
    background: #0E7AA8;
    color: #FFF;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

const TextSelected = styled.span`
    color: #101828;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
`;

const Divider = styled.div`
    width: 1px;
    height: 32px;
    flex-shrink: 0;
    background: #D0D5DD;
`;

const DeactivateButton = styled.button`
    display: flex;
    width: 195px;
    height: 39px;
    padding: 0 16px;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #FAB5AF;
    background: #FFF1F1;
    cursor: pointer;
    white-space: nowrap;
    
    span {
        color: #344054;
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 21px;
        white-space: nowrap;
    }
    
    &:hover {
        opacity: 0.9;
    }
`;

const ClearButton = styled.button`
    display: flex;
    width: 149.445px;
    height: 37px;
    padding: 0 12px;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #D0D5DD;
    background: #FFF;
    cursor: pointer;
    white-space: nowrap;
    
    span {
        color: #667085;
        text-align: center;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 21px;
        white-space: nowrap;
    }
    
    &:hover {
        opacity: 0.9;
    }
`;

const FilterContainerUsers = (props) => {
    const { rowChecked, handleDeactivateSelected, handleClearSelection } = props;

    if (!rowChecked || rowChecked.length === 0) {
        return null;
    }

    return (
        <Container>
            <NumberBadge>{rowChecked.length}</NumberBadge>
            <TextSelected>users selected</TextSelected>
            <Divider />
            <DeactivateButton onClick={handleDeactivateSelected}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M2.5 4.99935H4.16667M4.16667 4.99935H17.5M4.16667 4.99935V16.666C4.16667 17.108 4.34226 17.532 4.65482 17.8445C4.96738 18.1571 5.39131 18.3327 5.83333 18.3327H14.1667C14.6087 18.3327 15.0326 18.1571 15.3452 17.8445C15.6577 17.532 15.8333 17.108 15.8333 16.666V4.99935H4.16667ZM6.66667 4.99935V3.33268C6.66667 2.89065 6.84226 2.46673 7.15482 2.15417C7.46738 1.84161 7.89131 1.66602 8.33333 1.66602H11.6667C12.1087 1.66602 12.5326 1.84161 12.8452 2.15417C13.1577 2.46673 13.3333 2.89065 13.3333 3.33268V4.99935M8.33333 9.16602V14.166M11.6667 9.16602V14.166" stroke="#F04438" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Deactivate Selected</span>
            </DeactivateButton>
            <ClearButton onClick={handleClearSelection}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L4 12" stroke="#667085" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 4L12 12" stroke="#667085" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Clear Selection</span>
            </ClearButton>
        </Container>
    );
};

export default FilterContainerUsers;
